import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import 'semantic-ui-css/semantic.min.css';

import { selectCurrentUser } from './redux/user/user.selectors';
import { checkUserSession } from './redux/user/user.actions';

import HomePage from '../src/pages/homepage/HomePage.component';
import HowItWorksPage from '../src/pages/how-it-works/HowItWorksPage.component';
import XaaSAcademyPage from '../src/pages/xaas-academy/XaaSAcademyPage.component';
import FAQsPage from '../src/pages/faqs/FAQsPage.component';
import AboutPage from '../src/pages/about/AboutPage.component';
import WhyDebtPage from '../src/pages/why-debt/WhyDebtPage.component';
import LoginPage from '../src/pages/login/LoginPage.component';
import SignUpPage from '../src/pages/signup/SignUpPage.component';
import OnboardingPage from '../src/pages/onboarding/OnboardingPage.component';

import './App.css';

class App extends React.Component {

  componentDidMount() {
    const { checkUserSession } = this.props;
    checkUserSession();
  }

  render() {
    return (
      <div>
        {/* <Header/> */}
        <Switch>
          <Route exact path='/' render={
            () => this.props.currentUser ?
            (<OnboardingPage />) :
            (<HomePage />)
          } />
          {/* <Route exact path='/' component={HomePage} /> */}
          {/* <Route path='/shop' component={ShopPage} /> */}
          {/* <Route path='/checkout' component={CheckoutPage} /> */}
          <Route exact path='/how-it-works' 
            render={
              () => this.props.currentUser ? 
              (<Redirect to='/' />) 
              : 
              (<HowItWorksPage />)} 
          />
          <Route exact path='/xaas-academy' 
            render={
              () => this.props.currentUser ? 
              (<Redirect to='/' />) 
              : 
              (<XaaSAcademyPage />)} 
          />
          <Route exact path='/about' 
            render={
              () => this.props.currentUser ? 
              (<Redirect to='/' />) 
              : 
              (<AboutPage />)} 
          />
          <Route exact path='/why-debt' 
            render={
              () => this.props.currentUser ? 
              (<Redirect to='/' />) 
              : 
              (<WhyDebtPage />)} 
          />
          <Route exact path='/faqs' 
            render={
              () => this.props.currentUser ? 
              (<Redirect to='/' />) 
              : 
              (<FAQsPage />)} 
          />
          <Route exact path='/login' 
            render={
              () => this.props.currentUser ? 
              (<Redirect to='/' />) 
              : 
              (<LoginPage />)} 
          />
          <Route exact path='/signup' 
            render={
              () => this.props.currentUser ? 
              (<Redirect to='/' />) 
              : 
              (<SignUpPage />)} 
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser
});

const mapDispatchToProps = dispatch => ({
  checkUserSession: () => dispatch(checkUserSession())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
